import React from 'react'
import { ReferenceInput, SelectInput, TextInput, Filter } from 'react-admin'
import { get } from 'lodash'

export default props => {
  return (
    <Filter {...props}>
      <TextInput
        source='field_search'
        alwaysOn
        parse={value => {
          return {
            path: 'field_search',
            value: value,
            operator: 'CONTAINS'
          }
        }}
        format={value => {
          return get(value, 'value', '')
        }}
      />
      <ReferenceInput
        source='field_contractor'
        reference='node/contractor'
        sort={{ field: 'title', order: 'ASC' }}
        parse={value => {
          return {
            path: 'field_contractor.id',
            value: value,
            operator: '='
          }
        }}
        format={value => {
          return ''
        }}
      >
        <SelectInput optionText='attributes.title' />
      </ReferenceInput>
      <ReferenceInput
        source='field_firm'
        reference='node/firm'
        sort={{ field: 'title', order: 'ASC' }}
        parse={value => {
          return {
            path: 'field_firm.id',
            value: value,
            operator: '='
          }
        }}
        format={value => {
          return ''
        }}
      >
        <SelectInput optionText='attributes.title' />
      </ReferenceInput>
      <TextInput
        source='title'
        parse={value => {
          return {
            path: 'title',
            value: value,
            operator: 'CONTAINS'
          }
        }}
        format={value => {
          return get(value, 'value', '')
        }}
      />
    </Filter>
  )
}
